/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import styled from 'styled-components';

export const StyledLogin = styled.div`
  width: 480px;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);

  .dyc-login-register-main {
    position: relative;
    padding: 40px 60px;

    .ant-form-item {
      &.form-check {
        margin-top: -7px;
        margin-bottom: -25px;
      }
      .ant-input-affix-wrapper {
        padding: 0 12px;
      }
      input {
        height: 42px;
        font-size: 14px;
        color: #333;
      }

      .ant-form-explain {
        position: absolute;
        bottom: -22px;
        font-size: 12px;
      }
    }

    .dyc-svg-icon {
      width: 14px;
      height: 14px;
    }
    .account-login-block {
      display: none;
    }
    .qrcode-login-block {
      height: 440px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &.show-account-block {
      .account-login-block {
        display: block;
      }
      .qrcode-login-block {
        display: none;
      }
    }
  }
  .login-switch-btn {
    position: absolute;
    top: 0;
    right: 0;

    img {
      height: 55px;
      width: 55px;
    }
  }
  .form-item-sms {
    .ant-input-suffix {
      right: 0;

      .ant-btn {
        height: 42px;
        padding: 0 20px;
        border-radius: 0 4px 4px 0;
      }
    }
  }

  .form-submit-button.ant-btn {
    width: 100%;
    height: 42px;
  }
  .code-send-btn {
    margin-right: -12px;
  }
  .ant-tabs {
    .ant-tabs-nav {
      margin: 5px 0 30px;
      border-bottom: 0;
    }
    /* .ant-tabs-nav-list {
      flex: 1;
      justify-content: center;
    } */
    .ant-tabs-tab {
      width: 128px;
      font-size: 14px;
      padding-bottom: 6px;
      justify-content: center;
    }

    .ant-form-item {
      font-size: 14px;

      &:last-child {
        margin: -10px 0 20px;

        .ant-checkbox-wrapper {
          font-size: 14px;
        }
      }
    }
  }

  .login-form {
    &-forgot {
      float: right;
      color: #333;
      text-decoration: none;

      &:hover {
        color: #1283d5;
      }
    }
  }

  .dyc-login-others {
    .title {
      text-align: center;
      position: relative;
      margin-bottom: 15px;

      > span {
        font-size: 12px;
        display: inline-block;
        background: #fff;
        padding: 0 10px;
        position: relative;
        z-index: 50;
      }

      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 1px;
        background: #d7d7d7;
        left: 0;
        top: 10px;
      }
    }

    .icons {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: auto;
      height: 50px;
      width: 50px;
      border-radius: 28px;
      background-color: #3ec846;
      color: #fff;
      > a {
        margin: 0 8px;
      }
      svg {
        font-size: 32px;
      }
    }

    > p {
      text-align: center;
      padding: 20px 0 10px;
      font-size: 14px;
    }
  }
`;
